import * as React from 'react';
import { css } from 'aphrodite/no-important';
import {
  SemanticTagDataProps,
  SemanticTagThemeProps,
  getStyleBySize,
  getFontSizesBySemanticTag,
  sanitizeAttributes,
} from '../semanticTags/semanticTags.utils';
import { useTheme } from '../../theming/useTheme';

export const P: React.FunctionComponent<SemanticTagDataProps> = props => {
  const defaultFontSizes = getFontSizesBySemanticTag('p');
  const { fontSizesStyles } = useTheme<SemanticTagThemeProps>();
  const {
    children,
    styles = [],
    fontSizeSmall = defaultFontSizes.fontSizeSmall,
    fontSizeMedium = defaultFontSizes.fontSizeMedium,
    fontSizeLarge = defaultFontSizes.fontSizeLarge,
    ...attributes
  } = props;
  const styleBySize = getStyleBySize(fontSizesStyles, { fontSizeSmall, fontSizeMedium, fontSizeLarge });

  return (
    <p className={css(styleBySize, ...styles)} {...sanitizeAttributes(attributes)}>{children}</p>
  );
};
